import { render, staticRenderFns } from "./FaceDirectionResultEffectFaceDown4.vue?vue&type=template&id=3a221b03&"
import script from "./FaceDirectionResultEffectFaceDown4.vue?vue&type=script&lang=ts&"
export * from "./FaceDirectionResultEffectFaceDown4.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports